import { isPromise } from "../fn";

const fallback = handler => fn => {
	if (typeof handler !== "function") return fn;
	return (...args) => {
		const theHandler = err => handler(err, ...args);
		try {
			const result = fn(...args);
			return isPromise(result) ? result.catch(theHandler) : result;
		} catch (err) {
			return theHandler(err);
		}
	};
};

export default fallback;
